import nunjucks from 'nunjucks';

const env = new nunjucks.Environment(null, { autoescape: false });

export interface TemplateContext {
  agents: TemplateAgent[];
  gateway: {
    port: number;
    image?: string;
  };
  variables: Record<string, unknown>;
}

export interface TemplateAgent {
  agent_id: string;
  code_name: string;
  display_name: string;
  environment: string;
  port?: number;
}

/**
 * Renders a Nunjucks template string with the provided context.
 */
export function renderTemplate(templateStr: string, context: TemplateContext): string {
  return env.renderString(templateStr, context);
}
